<script>
import Layout from '@layouts/main'
import LatestMixes from '@views/browse-mixes/browse-latest-mixes'
import TrendingMixes from '@views/browse-mixes/browse-trending-mixes'
import RecentlyPlayedMixes from '@views/browse-mixes/browse-recently-played-mixes'

export default {
    name: 'BrowseMixes',
    page() {
        const isTrending = this.mainComponent === 'TrendingMixes'
        const title = isTrending ? 'Trending Mixes' : 'Latest Mixes'
        const description = isTrending
            ? 'The most popular electronic music mixes right now on FRISKY'
            : 'The latest electronic music mixes on FRISKY'
        const image = `${process.env.VUE_APP_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = isTrending
            ? 'https://frisky.fm/browse/mixes/trending'
            : 'https://frisky.fm/browse/mixes/latest'
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
    components: { Layout, LatestMixes, TrendingMixes, RecentlyPlayedMixes },
    props: {
        mainComponent: {
            type: String,
            default: 'LatestMixes',
        },
    },
    computed: {
        tabs() {
            return [
                {
                    to: { name: 'browse/mixes/latest' },
                    label: 'Latest',
                },
                {
                    to: { name: 'browse/mixes/trending' },
                    label: 'Trending',
                },
            ]
        },
        authTabs() {
            return [
                {
                    to: { name: 'browse/mixes/latest' },
                    label: 'Latest',
                },
                {
                    to: { name: 'browse/mixes/trending' },
                    label: 'Trending',
                },
                {
                    to: { name: 'browse/mixes/recently' },
                    label: 'Recently Played',
                },
            ]
        },
        loggedIn() {
            return this.$store.getters['auth/loggedIn']
        },
    },
}
</script>

<template>
    <Layout>
        <BaseContent
            class="page"
            title="Mixes"
        >
            <BaseTabPanel
                :tabs="loggedIn ? authTabs : tabs"
                class="tabs"
                is-underlined
                is-unpadded
                address-navigation
            />
            <component
                :is="mainComponent"
                class="component"
            />
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.tabs {
    margin-bottom: $s-xxl;
}

.page {
    min-height: 101vh;
}
</style>
